import React from "react";
import "../dashboard/css/privacypolicy.css";
import banner from "../dashboard/assets/privacypolicybanner.webp"; // adjust path if needed

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      {/* Banner Image */}
      <div
        className="privacy-banner"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <h1>Privacy Policy</h1>
      </div>

      {/* Intro Below Banner */}
      <div className="privacy-intro">
        <p>
          This Privacy Policy explains how <strong>BizzMark India</strong> collects,
          uses, stores, and protects your personal information.
        </p>
        <span>Last updated: January 2026</span>
      </div>

      {/* Main Content */}
      <div className="privacy-content">
        <section>
          <h2>1. Introduction</h2>
          <p>
            This Privacy Policy applies to the website operated by
            <strong> BizzMark India</strong> (referred to as “we”, “us”, or “our”).
            We are committed to protecting your privacy and ensuring transparency
            in how your personal information is handled.
          </p>
          <p>
            By accessing or using our website, you agree to the collection and use
            of information in accordance with this Privacy Policy.
          </p>
          <p>
            Website URL:{" "}
            <a
              href="https://bizzmarkindia.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://bizzmarkindia.com
            </a>
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect and process the following categories of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, email address, phone
              number, or other information voluntarily submitted via forms.
            </li>
            <li>
              <strong>Technical Information:</strong> IP address, browser type,
              operating system, device information, and referral URLs.
            </li>
            <li>
              <strong>Usage Information:</strong> Pages visited, time spent on
              pages, interactions, and navigation patterns.
            </li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To operate, maintain, and improve our services</li>
            <li>To respond to inquiries and customer support requests</li>
            <li>To communicate service-related updates</li>
            <li>To analyze website performance and usage trends</li>
            <li>To comply with legal and regulatory requirements</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance user experience,
            analyze traffic, and understand usage behavior.
          </p>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>
            We may use trusted third-party service providers such as analytics,
            hosting, or marketing platforms.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            Personal data is retained only as long as necessary to fulfill the
            purposes outlined in this Privacy Policy.
          </p>
        </section>

        <section>
          <h2>7. Data Security</h2>
          <p>
            We apply reasonable technical and organizational security measures
            to protect personal information.
          </p>
        </section>

        <section>
          <h2>8. Your Rights</h2>
          <p>
            Depending on applicable laws, you may have rights to access, correct,
            delete, or restrict the processing of your personal data.
          </p>
        </section>

        <section>
          <h2>9. Children&apos;s Privacy</h2>
          <p>
            Our website is not intended for children under the age of 13.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time.
          </p>
        </section>

        <section className="contact-section">
          <h2>11. Contact Information</h2>
          <p>
            If you have questions regarding this Privacy Policy, contact us at:
          </p>
          <p className="email">support@bizzmarkindia.com</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;